<!-- App.svelte -->

<script>

import { name, mmti, mmti_dict } from "./store";
import { Navigate } from 'svelte-router-spa';

const urlParams = new URLSearchParams(window.location.search);
const queryName = urlParams.get('name');
const queryMmti = urlParams.get('mmti');

if (queryName) {
    console.log(queryName);
    $name = queryName;
}

let mmti_ei = 0;
let mmti_ns = 0;
let mmti_ft = 0;
let mmti_pj = 0;

if (queryMmti) {
    console.log(queryMmti);
    $mmti = queryMmti;
} else {
    console.log($mmti_dict);

    // default: INFP
    // 동의 (+2) VS 미동의 (-2)
    // mmti_{+}{-}
    // - mmti_ei
    // - mmti_ns
    // - mmti_ft
    // - mmti_pj

    mmti_ei -= Number($mmti_dict['mmti1']);
    mmti_ei -= Number($mmti_dict['mmti2']);
    mmti_ns += Number($mmti_dict['mmti3']);
    mmti_ft += Number($mmti_dict['mmti4']);
    mmti_ns += Number($mmti_dict['mmti5']);
    mmti_pj -= Number($mmti_dict['mmti6']);
    mmti_pj += Number($mmti_dict['mmti7']);
    mmti_ns += Number($mmti_dict['mmti8']);
    //
    mmti_ft += Number($mmti_dict['mmti9']);
    mmti_ns -= Number($mmti_dict['mmti10']);
    mmti_ei += Number($mmti_dict['mmti11']);
    mmti_pj += Number($mmti_dict['mmti12']);
    mmti_pj += Number($mmti_dict['mmti13']);
    mmti_ei += Number($mmti_dict['mmti14']);
    mmti_ns += Number($mmti_dict['mmti15']);
    mmti_ft -= Number($mmti_dict['mmti16']);
    //
    mmti_ei += Number($mmti_dict['mmti17']);
    mmti_ft += Number($mmti_dict['mmti18']);
    mmti_ft += Number($mmti_dict['mmti19']);
    mmti_ns -= Number($mmti_dict['mmti20']);
    mmti_ft -= Number($mmti_dict['mmti21']);
    mmti_pj -= Number($mmti_dict['mmti22']);
    mmti_ei -= Number($mmti_dict['mmti23']);
    mmti_pj += Number($mmti_dict['mmti24']);
    //
    mmti_ei += Number($mmti_dict['mmti25']);
    mmti_pj -= Number($mmti_dict['mmti26']);
    mmti_ft -= Number($mmti_dict['mmti27']);
    mmti_ns += Number($mmti_dict['mmti28']);
    mmti_ei += Number($mmti_dict['mmti29']);
    mmti_ei -= Number($mmti_dict['mmti30']);
    mmti_ft += Number($mmti_dict['mmti31']);
    mmti_ei += Number($mmti_dict['mmti32']);
    //
    mmti_ei += Number($mmti_dict['mmti33']);
    mmti_ns += Number($mmti_dict['mmti34']);
    mmti_ft -= Number($mmti_dict['mmti35']);
    mmti_ns -= Number($mmti_dict['mmti36']);
    mmti_ei += Number($mmti_dict['mmti37']);
    mmti_ft += Number($mmti_dict['mmti38']);
    mmti_ft -= Number($mmti_dict['mmti39']);
    mmti_pj += Number($mmti_dict['mmti40']);

    console.log(mmti_ei)
    console.log(mmti_ns)
    console.log(mmti_ft)
    console.log(mmti_pj)

    // default: INFP
    $mmti = '';

    if (mmti_ei > 0) {
        $mmti += 'e';
    } else {
        $mmti += 'i';
    }

    if (mmti_ns >= 0) {
        $mmti += 'n';
    } else {
        $mmti += 's';
    }

    if (mmti_ft >= 0) {
        $mmti += 'f';
    } else {
        $mmti += 't';
    }

    if (mmti_pj >= 0) {
        $mmti += 'p';
    } else {
        $mmti += 'j';
    }

    console.log($mmti)
}

let mmti_type = '';
let mmti_summary = '';
let mmti_desc = '';
let mmti_tumblbug_button_fname = '';

if ($mmti === 'intj') {
    mmti_type = "용의주도한 전략개";
    mmti_summary = "상상력이 풍부하며 철두철미한 계획을 세우는 전략개형.";
    mmti_desc = "전략적 사고에 뛰어나고 풍부한 지식을 소유하고 있는 이들에겐 견줄 만한 강아지가 없죠. 이들은 펫스카우트 전략회의에는 확신에 찬 자신감으로 의견을 어필하지만, 다른 개 친구들의 가십거리에는 다소 관심이 없군요. 주인의 머리꼭대기에 있는 것 같은 이 친구들은 마음만 먹으면 펫스카우트 단장 스캇의 자리쯤은 그냥 차지할 수 있을 것 같기도 하네요.";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3T.png';
} else if ($mmti === 'intp') {
mmti_type =     "논리적인 사색개";
mmti_summary =  "끊임없이 새로운 지식에 목말라하는 혁신개형.";
mmti_desc =     "이 유형의 강아지는 '평범함'을 거부합니다. 이들은 그들이 가진 독창성과 창의력, 그리고 그들만의 독특한 관점과 왕성한 지적 호기심에 나름의 자부심을 가지고 있죠. 천재개로도 많이 알려진 이들은 펫스카우트 연맹지에 자주 등장하기도 합니다. 쉼 없이 생각에 몰두할 때도 있지만 친구들과 있을 때면 편안하고 밝은 모습도 보여준답니다. 이 친구들이 천재성을 마음껏 발휘할 수 있도록 도와준다면 펫스카우트 역사에 한 획을 그을지도...?";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3T.png';

} else if ($mmti === 'entj') {
 mmti_type =      "대담한 통솔개";
 mmti_summary =   "대담하고 상상력이 풍부한 진취적인 리더개형.";
 mmti_desc =      "이들은 천성적으로 타고난 리더입니다. 이 유형에 속하는 강아지는 멋진 카리스마와 자신감으로 다른 친구들을 이끌어줍니다. 도전과 지략을 진정 즐길 줄 아는 이들은 간식이 먹고싶어졌을 때나 산책을 가고싶어 졌을 때 한치도 뒤로 물러서는 법이 없죠. 그 어떤 것도 실현 가능하다고 믿는 통솔개형 강아지들은 펫스카우트 라이프를 윤택하게 해주는 일등공신이랍니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3T.png';

} else if ($mmti === 'entp') {
 mmti_type =      "뜨거운 논쟁을 즐기는 변론개";
 mmti_summary =   "지적인 도전을 두려워하지 않는 호기심 많은 똑똑개형.";
 mmti_desc =      "단순히 재미를 이유로 비판을 일삼기도 하는 이 유형의 강아지는 가만히 있는 친구도 괜히 한 번 건드려봅니다. 자신의 풍부한 지식과 타고난 유머감각을 증명해보일 수 있기 때문이죠. 가끔은 의도치 않게 친구를 서운하게 만들고선 후회의 길을 걷기도 합니다. 지루하고 고단한 일은 어떤 수를 써서라도 빠져나갈 궁리를 하는 얄미로운 강아지. 얄밉다가도 뒤돌아서면 생각나는 마성의 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3T.png';

} else if ($mmti === 'infj') {
 mmti_type =      "선의의 옹호개";
 mmti_summary =   "조용하고 신비로우며 샘솟는 영감으로 지칠 줄 모르는 이상주의개형.";
 mmti_desc =      "선의의 옹호개형 강아지는 나긋나긋한 목소리 뒤에 강직함을 숨기고 있으며, 옳다고 생각되는 일에는 열심히 투쟁합니다. 다른 강아지들과 스스럼없이 잘 어울리며, 따뜻하고 섬세하게 강아지 대 강아지로 이야기를 나누기도 하죠. 그러면서도 재충전할 수 있는 혼자만의 시간을 가지기를 원하기도 해요. 게으름 피우는 법이 없고 늘 열심히 활동하기 떄문에 모범 펫스카우트 단원 1순위랍니다. ";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3F.png';

} else if ($mmti === 'infp') {
 mmti_type =      "열정적인 중재개";
 mmti_summary =   "상냥한 성격으로 건강하고 밝은 사회에 앞장서는 낭만주의개형";
 mmti_desc =      "이 유형의 강아지는 항상 긍정적이고 더 나은 상황을 만들고자 노력하는 진정한 이상주의개입니다. 간혹 침착하고 내성적이며 수줍음이 많아 보이기도 하지만 내면에는 열정이 불꽃이 숨어있답니다. 이 유형의 강아지들은 언어능력이 뛰어나 강아지 말 뿐 아니라 고양이 언어, 비둘기 언어, 운 좋으면 인간 언어(?)까지도 습득해 화합을 도모합니다. 마음이 맞는 친구를 만나면 내면의 넘치는 영감을 경험할 수 있는 멋진 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3F.png';

} else if ($mmti === 'enfj') {
 mmti_type =      "정의로운 사회운동개";
 mmti_summary =   "넘치는 카리스마와 영향력으로 다른 강아지들을 압도하는 리더개형.";
 mmti_desc =      "카리스마와 충만한 열정을 가진 이 유형의 강아지는 살기 좋은 펫스카우트 사회를 위해 다른 강아지를 동참시키고 함께하는 데에서 큰 자부심과 행복을 느낍니다. 힘든 일도 앞장서는 책임감 있는 모습에 다른 강아지들은 최면에 걸린 듯 이끌리곤 하죠. 선한 마음과 순수한 열정으로 다른 강아지와 사람을 진심으로 대하는 모습이 멋진 펫스카우트의 빛과 소금이랍니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3F.png';

} else if ($mmti === 'enfp') {
 mmti_type =      "재기발랄한 활동개";
 mmti_summary =   "창의적이며 항상 즐거움을 찾아다니는 열정개형.";
 mmti_desc =      "이 유형의 강아지는 자유로운 사고의 소유자입니다. 다른 친구들과의 사회적, 정서적인 깊은 유대관계를 통해 큰 행복을 느끼는 이들은 종종 분위기 메이커 역할을 하기도 해요. 반복되는 일상에서는 답답함을 쉽게 느끼기 때문에 항상 새롭고 몰두할 수 있는 무언가를 탐색하곤 한답니다. 매력적이면서도 독립적인 성격으로 활발하면서도 정이 많은 인기만점의 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2N_3F.png';

} else if ($mmti === 'istj') {
 mmti_type =      "청렴결백한 논리주의개";
 mmti_summary =   "사실에 근거하여 사고하고 행동하는 현실주의개형.";
 mmti_desc =      "이 유형의 강아지는 순수한 견품을 가지고 있으면서도 헌신적으로 임무를 수행합니다. 자신이 맡은 역할에 책임을 다하며 그들이 하는 일에 큰 자부심을 가지고 있는 이들은 펫스카우트 사회에서 핵심 구성원 역할을 한답니다. 펫스카우트 수칙을 잘 지키지 않는 단원들은 이들에게 미움을 받을 수도 있으니 조심하세요. 목표를 달성하기 위해 시간과 에너지를 허투로 쓰지 않는 이들은 펫스카우트의 필수 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4J.png';


} else if ($mmti === 'isfj') {
 mmti_type =      "용감한 수호개";
 mmti_summary =   "소중한 친구들을 수호하는 데 진심인 보호개형.";
 mmti_desc =      "수호개형 강아지는 타고난 섬세함으로 상대방을 감동시키는 데 천부적인 소질이 있습니다. 가치 있다고 여기는 일이 있다면 가만히 앉아 있지 못하고 솔선수범 하는 이타주의적 성격을 가지고 있기도 하죠. 서로 응원하고 힘을 북돋워 주며 화목한 펫스카우트 사회를 꾸려나가는 것이 이들에게는 큰 축복입니다. 사랑을 나눌수록 커진다는 신념으로 다른 댕댕 친구들에게 베풀 줄 아는 따수운 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4J.png';


} else if ($mmti === 'estj') {
 mmti_type =      "엄격한 관리개";
 mmti_summary =   "질서를 모든 것의 기초로 삼는 본보기개형.";
 mmti_desc =      "관리개형 강아지는 펫스카우트의 질서를 정립하는데 이바지하는 대표적인 유형입니다. 그들은 고된 일도 마다하지 않고 기꺼이 뛰어들어 타의 모범이 되곤 합니다. 정직하고 헌신적이며 견풍당당한 이들은 험난한 길일지라도 조언을 통하여 그들이 옳다고 생각하는 길로 친구들을 인도하죠. 무능력, 태만, 부정직한 단원이 이들을 시험에 들게 하는 경우 불호령을 내리기도 합니다. 단원들을 단결시키는 데에 일가견이 있기도 한 이들은 펫스카우트 내에서 다른 친구들을 이끄는 전형적인 모범 단원입니다. ";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4J.png';


} else if ($mmti === 'esfj') {
 mmti_type =      "사교적인 외교개";
 mmti_summary =   "섬세하고 사교적인 성향으로 친구를 돕는데 열정적인 세심개형.";
 mmti_desc =      "이 유형은 한마디로 \"\"인기만점\"\"입니다. 이들은 종종 펫스카우트 소모임에서 분위기를 좌우하며 많은 친구들의 스포트라이트를 받습니다. 또한, 주위 단원들에게 끊임없는 관심과 애정을 발산하여 즐겁게 해주고자 노력한답니다. 천성적으로 사교적인 성향인 이들은 당신과 주변 친구들의 일거수일투족을 모두 알고싶어해요. 사료의 영양성분과 같은 복잡한 대화 주제는 이들의 관심을 오래 잡아두지 못합니다. 대신 이들은 미용 정보, 펫스카우트 회장단의 비밀 같은 대화 주제에 더 많은 관심을 보이죠. 그래도 친구의 진지한 고민에는 그 누구보다 따뜻한 대화상대가 되어주는 대체불가 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4J.png';


} else if ($mmti === 'istp') {
 mmti_type =      "만능 재주개";
 mmti_summary =   "대담하고 현실적인 성향으로 다양한 활동도 거뜬 없는 탐험개형.";
 mmti_desc =      "이 유형의 강아지는 냉철한 이성주의적 성향과 왕성한 호기심을 자랑합니다. 이들은 산책 한번을 가더라도 직접 만지고 눈으로 보면서 주변 세상을 탐색하는 걸 좋아해요. 놀이를 익히고 훈련 하는 데 재능이 있는 이들은 빠른 속도로 견생 노하우를 하나하나 터득해 나갑니다. 이들은 스스로 깨달은 노즈워크 핵심 성공 비결을 친구들에게 알려줄 때 세상 행복함을 느낍니다. 늘 전보다 성장한 모습으로 다른 친구들에게 영감을 주는 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4P.png';


} else if ($mmti === 'isfp') {
 mmti_type =      "호기심 많은 예술개";
 mmti_summary =   "늘 도전할 준비가 되어 있는 매력만점 모험개형.";
 mmti_desc =      "이 유형의 강아지는 언제나 새로운 것을 찾아 시도합니다. 이들은 강아지에게 기대되는 사회적 관습의 한계를 뛰어넘고자 합니다. 기존의 행동양식이나 관습에 도전장을 내밀며 \"\"저를 가두려 하지 마세요!\"\" 라고 수없이 외치죠. 어디로 튈 지 모르는 즉흥적 성향이 있어 이들을 예측하는 건 어려울 지도 모릅니다. 그러나 이러한 변덕들 또한 이들에게는 자아를 찾아나서는 과정입니다. 이러나 저러나 해도 톡톡 튀는 매력의 거부할 수 없는 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4P.png';


} else if ($mmti === 'estp') {
 mmti_type =      "모험을 즐기는 사업개";
 mmti_summary =   "아슬아슬하고 과감한 견생을 즐길 줄 아는 진정한 모험개형.";
 mmti_desc =      "펫스카우트 사회에 지대한 영향을 주는 사업가형 반려견은 여러 강아지가 모인 자리에서 요리조리 휙휙 옮겨다니는 것을 볼 수 있습니다. 박력있으면서도 친근한 모습으로 주변 강아지들을 기쁘게 만드는 이들은 확신의 관종입니다. 복잡하고 난해한 놀이는 이들의 관심을 오래 붙잡아두지 못합니다. 그들은 생각보다 몸이 앞서기도 해 가끔 실수를 하기도 하지만, 행동력이 끝내주는 멋진 펫스카우트 단원입니다. ";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4P.png';


} else if ($mmti === 'esfp') {
 mmti_type =     "자유로운 영혼의 스타개";
 mmti_summary =  "주위에 있으면 지루할 틈이 없을 정도로 끼와 에너지가 넘치는 엔터테이너개형.";
 mmti_desc =     "갑자기 흥얼거리고 즉흥적으로 댄스타임을 시작하는 강아지가 있다면 ESFP형일 가능성이 큽니다. 이들은 순간의 흥분되는 감정이나 상황에 쉽게 빠져들며, 주위 친구들도 그런 느낌을 함께 즐기길 원합니다. 그러면서도 주위 단원들 뿐만 아니라 당신과 당신의 주변사람까지 위로하고 용기를 북돋아주죠. 좋은 친구들과 함께일 때 가장 행복한 매력만점 흥부자 펫스카우트 단원입니다.";
    mmti_tumblbug_button_fname = 'tumblbug_2S_4P.png';


}


// TODO: (sanggyu) 새로고침 시 mmti_dict 초기화 -> home 으로 이동


// TODO: (sanggyu) name 또는 mmti 값이 없을 시 home 으로 이동 


if (!Kakao.isInitialized()) {
    Kakao.init('05ec94bac813c456fda808d6692f4891');
}

function sendLink() {

    let title = $name + '의 MMTI 는 "' + mmti_type + '" ' + ($mmti).toUpperCase() + ' 인가봐요~';

    Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
            title: title,
            description: '우리 댕댕이의 MMTI 는 뭔지 궁금하지 않으신가요!?',
            imageUrl: 'https://storage.googleapis.com/covelab-mmti/result/' + $mmti + '.jpg',
            link: {
                mobileWebUrl: 'https://mmti.app/result?name=' + $name + '&mmti=' + $mmti,
                webUrl: 'https://mmti.app/result?name=' + $name + '&mmti=' + $mmti,
            }
        },
        itemContent: {
            profileText: '멍-뭉-티아이 : 강아지를 위한 MBTI',
            profileImageUrl: 'https://storage.googleapis.com/covelab-mmti/home_logo.png',
        },
        buttons: [
            {
                title: '검사하러 가기',
                link: {
                    mobileWebUrl: 'https://mmti.app',
                    webUrl: 'https://mmti.app',
                },
            },
        ],
    })
}

</script>

<style>
.hero-body {
    background: #f5f5f6; 
}

.is-absolute {
    position: absolute;
}

.center {
    margin-left: auto;
    margin-right: auto;
}

body, html {
  -webkit-tap-highlight-color: transparent; 
}
</style>

<body>
<section class="hero is-fullheight">
<div class="hero-body">
<div class="container has-text-centered">
<div class="columns is-mobile center" style="max-width: 400px;">
    <div class="column">

    <h1 class="title is-6">
    우리 <span class="title is-4"> <b> "{$name}" </b> </span> 의 
    <br> 
    MMTI 는 바로바로:
    </h1>

    <figure class="image container is-square mt-5 mb-5">
    <img src="https://storage.googleapis.com/covelab-mmti/result/{$mmti}.jpg">
    </figure>

    <h1 class="title is-6">
    {mmti_summary}
    </h1>

    <h2 class="subtitle is-6 mt-1 has-text-left">
    {mmti_desc}
    </h2>

    </div>
</div>

<!--
<div class="columns is-mobile center" style="max-width: 400px;">

    <div class="column p-0">
    <div class="container">
    <a id="t-btn" href="https://tum.bg/7MbrAR" target="_blank">
    <figure class="image container"><img src="/{mmti_tumblbug_button_fname}" ></figure>
    <h1 class ="title is-6 is-overlay has-text-black has-text-left" style="position: absolute; top: 50%; left: 50%; transform: translate(-12%, -37%);">
    <p>멍-뭉-티아이 (MMTI)</p>
    <p>뱃지 당장 달아주러 가기</p>
    </h1>
    </a>
    </div>
    </div>


</div>
-->

<div class="columns is-mobile center" style="max-width: 400px;">

    <div class="column p-2">
    <div class="container">
    <a id="create-kakao-link-btn" href="javascript:void(0);" on:click={sendLink}>
    <figure class="image container"><img src="/kakaotalk.png"></figure>
    <h1 class ="title is-7 is-overlay has-text-black has-text-left" style="position: absolute; top: 50%; left: 50%; transform: translate(-25%, -35%);">
    <p>공유하기</p>
    </h1>
    </a>
    </div>
    </div>

    <div class="column p-2">
    <div class="container">
    <a id="r-btn" href="/">
    <figure class="image container"><img src="/retry_0304.png"></figure>
    <h1 class ="title is-7 is-overlay has-text-white has-text-left" style="position: absolute; top: 50%; left: 50%; transform: translate(-25%, -35%);">
    <p>다시 검사하기</p>
    </h1>
    </a>
    </div>
    </div>

</div>

</div>
</div>
</section>
</body>
